import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, throwError, timeout } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AddressBookService {
  private apiAddressBookUri = `${environment.apiUri}/address-book`;

  constructor(private http: HttpClient) {}

  createAddressBookEntry(entry: {
    campaign: string;
    owner: number;
    phone: string;
  }): Observable<any> {
    return this.http
      .post<any>(this.apiAddressBookUri, entry, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  updatePhoneNumberStatus(publicId: string, status: { status: number }): Observable<any> {
    return this.http
      .post<any>(`${this.apiAddressBookUri}/${publicId}/0`, status, {
        withCredentials: true,
      })
      .pipe(catchError(this.handleError));
  }

  getCampaignsByPublic(publicId: string): Observable<{ data: any[] }> {
    const url = `${this.apiAddressBookUri}/${publicId}`;
    return this.http
      .get<{ data: any[] }>(url, { withCredentials: true })
      .pipe(
        timeout(30000), // Add a 30-second timeout
        catchError(this.handleError)
      );
  }

  getTranscriptionsByPublic(publicId: string): Observable<{ data: any[] }> {
    const url = `${this.apiAddressBookUri}/transcriptions/${publicId}`;
    return this.http
      .get<{ data: any[] }>(url, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  getTranscriptionAudioByPublic(publicId: string): Observable<{ data: string }> {
    const url = `${this.apiAddressBookUri}/transcriptions/record/${publicId}`;
    return this.http.get<{ data: string }>(url, { withCredentials: true }).pipe(
      catchError(this.handleError)
    );
  }

  getPaginatedCampaigns(
    campaignPublic: string,
    page: number,
    pageSize: number,
    sortBy?: string,
    sortOrder?: string,
    filters?: any
  ): Observable<any> {
    const apiUrl = `${this.apiAddressBookUri}/${campaignPublic}/${page}/${pageSize}`;
    console.log('API Call Triggered: ', apiUrl);
  
    const body: Record<string, any> = { filters };
    if (sortBy) body['sort_by'] = sortBy;
    if (sortOrder && sortBy) body['sort_order'] = sortOrder;
  
    console.log('Request Body: ', body);
  
    return this.http.post<any>(apiUrl, body, { withCredentials: true }).pipe(
      timeout(30000), // Add a 30-second timeout
      catchError((error) => {
        console.error('Request Failed: ', error);
        // Przepusc ORYGINALNY blad (z .status), zeby widok mogl rozpoznac 404/500 = brak wynikow filtra.
        return throwError(() => error);
      })
    );
  }
  
  
  

  private handleError(error: any) {
    console.error("An error occurred:", error);
    return throwError("Something bad happened; please try again later.");
  }
}
